import { type ChainflipAsset } from '@chainflip/utils/chainflip';
import { useGqlQuery } from './useGqlQuery';
import { getOraclePricesQuery } from '../graphql/cache/assets';

// oracle price refer to the chainlink oracle price of the asset tracked on the state chain
export const useOraclePrices = () => {
  const { data } = useGqlQuery(getOraclePricesQuery, {
    context: { clientName: 'statechainCache' },
    refetchInterval: 10000,
  });

  const prices = data?.prices?.nodes.map((price) => ({
    asset: price.baseAsset,
    usdPrice: price.price,
  }));

  return prices;
};

export const useOraclePrice = (asset: ChainflipAsset) => {
  const prices = useOraclePrices();
  return prices?.find((price) => price.asset === asset)?.usdPrice;
};
